import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, isRef as _isRef, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex w-100" }
const _hoisted_2 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_3 = {
  key: 1,
  class: "flex-fill text-truncate button-descr"
}

import {ref} from 'vue';
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {BigIconFlexButtonExposeInterface} from "~/cabinet/vue/interface/button/Interface";
import {Icon} from "~/cabinet/vue/interface/icon/IconInterface";



const __default__ = {
    name: "SideMenuButton"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    descr: {},
    icon: {},
    popperClass: {},
    popoverPlacement: {},
    badge: {},
    tooltip: {}
  },
  emits: ["click"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let popoverModel = ref(false);


function closePopover() {
    popoverModel.value = false;
}

__expose<BigIconFlexButtonExposeInterface>({
    closePopover
});

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    disabled: !_ctx.$slots.popover,
    visible: _unref(popoverModel),
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(popoverModel) ? (popoverModel).value = $event : popoverModel = $event)),
    "popper-class": __props.popperClass,
    placement: __props.popoverPlacement,
    trigger: "click"
  }, _createSlots({
    reference: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(`d-flex flex-column core-ui-side-menu-button flex-fill ${_ctx.$attrs.class ?? ''}`)
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          class: _normalizeClass(`text-center w-100 position-relative  button`),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$nextTick(() => _ctx.$nextTick(() => _unref(emits)('click')))))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (__props.icon || _ctx.$slots.icon)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    (__props.badge)
                      ? (_openBlock(), _createBlock(_component_el_badge, {
                          key: 0,
                          class: "badge",
                          type: "danger",
                          value: __props.badge
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true),
                    (!__props.icon)
                      ? _renderSlot(_ctx.$slots, "icon", { key: 1 })
                      : (_openBlock(), _createBlock(FontAwesomeIcon, {
                          key: 2,
                          icon: __props.icon,
                          regular: ""
                        }, null, 8, ["icon"]))
                  ]))
                : _createCommentVNode("", true),
              (__props.descr)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.descr), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 3
        })), [
          [_directive_my_tooltip, __props.tooltip]
        ])
      ], 2)
    ]),
    _: 2
  }, [
    (_unref(popoverModel))
      ? {
          name: "default",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "popover")
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["disabled", "visible", "popper-class", "placement"]))
}
}

})